export const REPURPOSE_CATEGORIES = [
  {
    label: "Social",
    targets: [
      { type: "LinkedIn Post", platform: "LinkedIn" },
      { type: "Carousel", platform: "Instagram", hasSlidCount: true },
      { type: "X (Twitter) Thread", platform: "X (Twitter)", hasThreadCount: true },
      { type: "Story Post", platform: "Facebook" },
    ],
  },
  {
    label: "Email",
    targets: [
      { type: "Email (Single)", platform: "Email List" },
      { type: "Email Sequence (Multi-Part)", platform: "Email List", hasEmailCount: true },
      { type: "Welcome Email", platform: "Email List" },
      { type: "Nurture Email", platform: "Email List" },
      { type: "Pitch / Sales Email", platform: "Email List" },
    ],
  },
  {
    label: "Long-Form",
    targets: [
      { type: "Newsletter Section", platform: "Substack" },
      { type: "Blog Post", platform: "Blog / Website" },
      { type: "Substack Article", platform: "Substack" },
      { type: "Lead Magnet Section", platform: "Lead Magnet (PDF)" },
    ],
  },
  {
    label: "Video & Audio",
    targets: [
      { type: "Short-Form Video Script", platform: "YouTube" },
      { type: "Long-Form Video Script", platform: "YouTube" },
      { type: "Podcast Intro / Outro", platform: "Podcast" },
    ],
  },
  {
    label: "Sales & Pages",
    targets: [
      { type: "Opt-In Landing Page Copy", platform: "Landing Page" },
      { type: "Sales Page Section", platform: "Sales Page" },
      { type: "Case Study", platform: "Blog / Website" },
      { type: "Bio / About Section", platform: "Blog / Website" },
    ],
  },
  {
    label: "Engagement",
    targets: [
      { type: "Poll / Engagement Post", platform: "LinkedIn" },
      { type: "Poll / Engagement Post", platform: "X (Twitter)" },
      { type: "Poll / Engagement Post", platform: "Instagram" },
    ],
  },
];

export const ALL_TARGETS = REPURPOSE_CATEGORIES.flatMap((c) => c.targets);

export const REPURPOSE_TONES = [
  "Direct", "Sharp", "Calm", "Contrarian", "Insightful", "Practical",
  "Urgent", "Warm", "Provocative", "Authoritative", "Conversational",
];

export const EMOJI_LEVELS = [
  { value: "none", label: "None", desc: "Text only" },
  { value: "light", label: "Light", desc: "1-2 per section" },
  { value: "medium", label: "Medium", desc: "Key points & CTAs" },
  { value: "heavy", label: "Heavy", desc: "Visually rich" },
];

export const PLATFORM_STYLES = {
  "LinkedIn": { font: "system-ui", maxWidth: "520px", lineHeight: "1.6", hint: "LinkedIn-ready" },
  "Instagram": { font: "system-ui", maxWidth: "400px", lineHeight: "1.5", hint: "Carousel/Caption" },
  "X (Twitter)": { font: "system-ui", maxWidth: "480px", lineHeight: "1.4", hint: "Thread-ready" },
  "Facebook": { font: "system-ui", maxWidth: "520px", lineHeight: "1.6", hint: "Facebook post" },
  "Email List": { font: "Georgia, serif", maxWidth: "580px", lineHeight: "1.7", hint: "Email-ready" },
  "Substack": { font: "Georgia, serif", maxWidth: "620px", lineHeight: "1.8", hint: "Newsletter-ready" },
  "Blog / Website": { font: "Georgia, serif", maxWidth: "680px", lineHeight: "1.8", hint: "Blog-ready" },
  "YouTube": { font: "monospace", maxWidth: "600px", lineHeight: "1.5", hint: "Script-ready" },
  "Podcast": { font: "monospace", maxWidth: "600px", lineHeight: "1.5", hint: "Script-ready" },
  "Landing Page": { font: "system-ui", maxWidth: "560px", lineHeight: "1.6", hint: "Landing page copy" },
  "Sales Page": { font: "system-ui", maxWidth: "560px", lineHeight: "1.6", hint: "Sales copy" },
  "Lead Magnet (PDF)": { font: "Georgia, serif", maxWidth: "640px", lineHeight: "1.7", hint: "PDF section" },
};

export const getPlatformStyle = (platform) => PLATFORM_STYLES[platform] || PLATFORM_STYLES["LinkedIn"];
